var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPrivateMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_152437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5102 12.7754V20.7076H6.30536V12.7754H4V23.2203H6.40341H7.14292H13.6709V26.9647H15.9763V23.2203H22.6726H23.2273H25.8156V12.7754H23.5102Z",
    fill: "#8A939E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.60938,
    y: 1,
    width: 9.97283,
    height: 16.2058,
    fill: "#8A939E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_152437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8156,
    height: 26.802,
    fill: "white",
    transform: "translate(4 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivateMicOn);
export default __webpack_public_path__ + "static/media/ic_private_mic_on.03144b7f47b37f427396817ba8a4993f.svg";
export { ForwardRef as ReactComponent };